<template>
  <div id="management-dyuser-info">
    <!-- info area -->
    <el-card class="box-card" shadow="never">
      <el-form :inline="false" :model="userInfo" class="demo-form-inline" label-width="100px" >
        <el-row>
          <el-col :span="6">
            <el-form-item label="用户姓名">
              <el-input v-model.trim="userInfo.name" :disabled="true" placeholder="用户姓名" />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="度言员工编号">
              <el-input v-model.trim="userInfo.dyAccountId" placeholder="度言员工编号" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- button area -->
      <div class="button-area">
        <el-button  type="primary" @click="save">保存</el-button>
      </div>
    </el-card>

    <div id="management-user" class="table-section">
      <div class="query-section">
        <el-card class="box-card" shadow="never">
          <el-form :inline="true" :model="searchParams" class="form-inline" >
            <el-form-item label="用户名">
              <el-input v-model.trim="searchParams.agentName" placeholder="用户名" />
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model.trim="searchParams.mobile" placeholder="手机号" />
            </el-form-item>
            <el-form-item label="角色">
              <el-select v-model="searchParams.roleId" placeholder="请选择">
                <el-option v-for="(item, index) in userRoleList" :key="index" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="" @click="clear">清空</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <div class="table-section">
        <el-table :data="manageUserList" :header-row-style="headerRowStyle" border highlight-current-row
          max-height="550px" style="width: 100%">
          <el-table-column label="选择" width="80px">
            <template slot-scope="scope">
              <input type="radio" name="id" @click="radioFunc(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="用户姓名" />
          <el-table-column prop="mobile" label="手机号" />
          <el-table-column label="角色为">

            <template slot-scope="scope">
              <span>{{ roleFilter(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dyAccountId" label="度言员工编号" />
        </el-table>
      </div>

      <div class="pagination-section">
        <el-pagination :page-size="pageSize" :page-sizes="[5, 10, 15, 20]" :total="manageUserListTotalCount"
          layout="total, sizes, prev, pager, next" @current-change="changePage" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as manageApi from '../../api/manage.js'
import { getDictionaryList } from "@/api/manage";

export default {
  name: 'management-dyuser-info',
  data() {
    return {
      radio: '1',
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      userInfo: {
        name:'',
        dyAccountId:'',
        id:0,
        type: 1
      },
      modifyInfo: {},
      institutionTree: [],
      userRoleList: [],
      searchParams: {
        type: 0
      },
      pageSize: 10,
      page: 1
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'manageUserList',
      'manageUserListTotalCount'
    ]),
    agentId() {
      return this.$route.params.uid
    }
  },
  // watch: {
  //   userInfo: {
      // handler(n, o) {
      //   if (n.institutionInfo && n.institutionInfo.length) {
      //     this.institutionTree.forEach(item => {
      //       if (item.value !== n.institutionInfo[0][0]) item.disabled = true
      //     })
      //   } else {
      //     this.institutionTree.forEach(item => {
      //       delete item['disabled']
      //     })
      //   }
      // },
  //     deep: true,
  //     immediate: true
  //   }
  // },
  async created() {
    // 用户角色
    const fdRoleRes = await getDictionaryList("fd_role");
    fdRoleRes.data.map((item) => {
      this.userRoleList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
    this.loadUsers()
  },
  methods: {
    roleFilter(row) {
      for(let i=0;this.userRoleList && i<this.userRoleList.length;i++) {
        let item = this.userRoleList[i]
        if(item.value == row.role) {
          return item.label
        }
      }
      return ''
    },
    ...mapActions([
      'fetchManageUserList'
    ]),
    radioFunc(row) {
      console.log('row',row)
      this.userInfo.name = row.name
      this.userInfo.dyAccountId = row.dyAccountId
      this.userInfo.id = row.id
      console.log('userInfo',this.userInfo)
    },
    changePage(currentPage) {
      this.page = currentPage
      this.loadUsers()
    },
    loadUsers() {
      this.searchParams.userId = this.currentUser.id
      this.fetchManageUserList({ searchParams: this.searchParams, current: this.page, size: this.pageSize, queueType: this.type })
    },
    search() {
      this.page = 1
      this.loadUsers()
    },
    clear() {
      this.searchParams = {
        type: 0
      }
    },
    preparePostData() {
      this.userInfo.opId = this.currentUser.id
      this.userInfo.institutionId = this.userInfo.institutionInfo[0][0]
      const workQueueIds = []
      if (this.userInfo.institutionInfo.length) {
        this.userInfo.institutionInfo.forEach(item => {
          workQueueIds.push(item[1])
        })
      }
      this.userInfo.workQueueIds = workQueueIds
    },
    save() {
      if (!this.userInfo.name) {
        this.$message.warning('请先选择用户')
        return
      }
      if (!this.userInfo.dyAccountId) {
        this.$message.warning('请先输入度言员工编号')
        return
      }
      // this.preparePostData()
      manageApi.updateUserDyAccountId(this.userInfo).then((res) => {
        if (res.data === 'success') {
          // this.$router.replace({ name: 'manage-user-info', params: { uid: res.data.data.id }})
          this.$notify({
            title: '保存成功！',
            message: '2秒自动关闭',
            type: 'success',
            duration: 5000
          })
          setTimeout(() => {
            window.history.go(-1)
          }, 2000)
        } else {
          this.$notify.error({
            title: '出错了！',
            message: res.data.msg,
            type: 'error',
            duration: 5000
          })
        }
      })
    },
    back() {
      window.history.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-area {
  float: right;
  margin-bottom: 20px;
}

#management-user-info .el-input {
  width: auto;
}
</style>
